import { ObjectUtils } from '@pbk-web/utils';
import type { AxiosResponse } from 'axios';

/**
 * Trim the request and response bodies so that we protect sensitive information.
 * @param res The axios response
 */
export const trimResponseData = (res: AxiosResponse) => {
  const clone = ObjectUtils.DeepClone(res);
  if (clone.data?.data) delete clone.data.data;
  // The request body as well as the response body. Document annotation posts the whole
  // document's annotations and comments, so an unredacted error report would carry
  // customer content out to Sentry.
  if (clone.config?.data) delete clone.config.data;
  return clone;
};

/**
 * Copy a rejected axios error without its request body; the caller keeps the original.
 * Keeps the prototype so AxiosError.toJSON still runs when Sentry serialises it.
 * @param err The rejected axios error
 */
export const trimErrorData = <T extends object>(err: T): T => {
  const { config } = err as { config?: object };
  return Object.assign(Object.create(Object.getPrototypeOf(err)), err, config ? { config: { ...config, data: undefined } } : {});
};
